import React from "react";
import vesselCallRoutes from "./vesselCall/vesselCallRoutes";
import arrivalDeclarationRoutes from "./arrivalDeclaration/arrivalDeclarationRoutes";
import departureDeclarationRoutes from "./departureDeclaration/departureDeclarationRoutes"
import preArrivalNoticeRoutes from "./preArrivalNotice/preArrivalNoticeRoutes";
import sscecRoutes from "./sscec/sscecRoutes";
import dosRoutes from "./declarationSecurity/dosRoutes";
import amendmentRout from "./amendment/amendmentRoutes";

const applicationRoutes = [
    ...vesselCallRoutes,
    ...arrivalDeclarationRoutes,
    ...dosRoutes,
    ...departureDeclarationRoutes,
    ...preArrivalNoticeRoutes,
    ...sscecRoutes,
    ...amendmentRout,
    {
        path: "/applications/home",
        component: React.lazy(() => import("./Home")),
    },
    //Entry Permit
    {
        path: "/applications/entryPermit/list",
        component: React.lazy(() => import("./entryPermit/EntryPermitList")),
    },
    {
        path: "/applications/entryPermit/:viewType/:epAppId",
        component: React.lazy(() => import("./entryPermit/EntryPermitFormDetails")),
    },

    //Pre-Arrival Security Information
    {
        path: "/applications/cargoSecurityInfo/list",
        component: React.lazy(() =>
            import("./cargoSecurityInfo/CargoSecurityList")
        ),
    },
    {
        path: "/applications/cargoSecurityInfo/:viewType/:appId",
        component: React.lazy(() =>
            import("./cargoSecurityInfo/CargoSecurityFormDetails")
        ),
    },

    //Pilot Order
    {
        path: "/applications/pilotOrder/list",
        component: React.lazy(() =>
            import("./pilotOrder/PilotOrderList")
        ),
    },
    {
        path: "/applications/pilotOrder/:viewType/:appId",
        component: React.lazy(() =>
            import("./pilotOrder/PilotOrderFormDetails")
        ),
    },

];

export default applicationRoutes;

